<template>
	<div class="device-battery-container">
		<!-- 筛选条件区域 -->
		<el-card class="mb-6" shadow="hover">
			<template #header>
				<div class="flex items-center">
					<i class="el-icon-filter text-primary mr-2"></i>
					<span>筛选条件</span>
				</div>
			</template>
			<el-form :model="filterForm" inline label-width="150px">
				<el-form-item label="设备IMEI">
					<el-input v-model="Dform.titleValue" placeholder="请输入设备IMEI"></el-input>
				</el-form-item>
			
				<el-form-item label="开始时间">
					<el-date-picker v-model="Dform.startTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
						value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item>
		
				<el-form-item label="结束时间">
					<el-date-picker v-model="Dform.terminalTime" type="datetime" format="YYYY-MM-DD HH:mm:ss"
						value-format="YYYY-MM-DD HH:mm:ss" placeholder="选择日期时间">
					</el-date-picker>
				</el-form-item>
			
				<el-form-item label="图表类型">
					<el-radio-group v-model="chartType">
						<el-radio label="scatter">散点图</el-radio>
						<el-radio label="line">折线图</el-radio>
						<el-radio label="bar">柱状图</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="applyFilter">查询</el-button>
					<el-button @click="resetFilter">重置</el-button>
				</el-form-item>
			</el-form>
		</el-card>

		<div class="box" ref="chartContainer"></div>
	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import { electric } from '@/assets/api/api'

	export default {
		name: 'DeviceBatteryECharts',
		data() {
			return {
				// 筛选表单
				Dform: {
					titleValue: '',
					schoolValue: '',
					startTime: '',
					terminalTime: '',
				},
				// 图表类型
				chartType: 'line',

				// 设备信息
				deviceInfo: {
					deviceId: '863565051303590',
					deviceType: '温度传感器',
					location: '办公室A',
					installDate: '2025-01-15',
					status: '正常',
					lastReportTime: '',
					batteryLevel: 0
				},

				// ECharts实例
				batteryChart: null,
				// 表格数据
				batteryData: [],
				searchQuery: '',
				currentPage: 1,
				pageSize: 10,
				total: 0,

				// 全屏状态
				isFullscreen: false
			};
		},
		computed: {
			filteredBatteryData() {
				if (!this.searchQuery) return this.batteryData;

				const query = this.searchQuery.toLowerCase();
				return this.batteryData.filter(item => {
					return item.createDate.toLowerCase().includes(query) ||
						item.bat.toString().includes(query);
				});
			},

			paginatedData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				return this.filteredBatteryData.slice(start, end);
			}
		},
		created() {
			// 初始化数据
			this.generateMockData();
		},
		mounted() {
			// 创建图表
			this.createChart();

			// 监听窗口大小变化，调整图表
			window.addEventListener('resize', this.resizeChart);
		},
		beforeDestroy() {
			// 移除事件监听
			window.removeEventListener('resize', this.resizeChart);

			// 销毁图表
			if (this.batteryChart) {
				this.batteryChart.dispose();
			}
		},
		methods: {
			// 生成模拟数据
			generateMockData() {
				this.batteryData = [];

				let params = {
					imei: this.Dform.titleValue,
					startTime: this.Dform.startTime,
					endTime: this.Dform.terminalTime,
					userId: JSON.parse(localStorage.getItem('user')).id,
				}
				electric(params).then((res) => {
					console.log(res, '电量统计');
					this.batteryData = res.data
					// 更新设备信息
					if (this.batteryData.length > 0) {
						// 找到最新的上报数据
						const latestData = this.batteryData.reduce((latest, current) => {
							return new Date(current.createDate) > new Date(latest.createDate) ? current :
								latest;
						}, this.batteryData[0]);

						this.deviceInfo.lastReportTime = latestData.createDate;
						this.deviceInfo.batteryLevel = latestData.bat;
						this.deviceInfo.status = this.getDeviceStatus(latestData.bat);
					}
					this.total = this.batteryData.length;
					this.updateChart();
				}).catch((err) => {
					console.log(err);
				})
			},

			// 创建图表
			createChart() {
				// 获取DOM元素
				const chartDom = this.$refs.chartContainer;

				// 初始化图表
				this.batteryChart = echarts.init(chartDom);

				// 设置图表配置项
				const option = this.getChartOptions();

				// 应用配置
				this.batteryChart.setOption(option);
			},

			// 获取图表配置
			getChartOptions() {
				// 准备图表数据
				const chartData = this.batteryData.map(item => {
					return [
						// 将日期时间字符串转换为时间戳
						new Date(item.createDate).getTime(),
						item.bat,
						item.bat < 20 ? 'low' : (item.bat < 50 ? 'medium' : 'high')
					];
				});

				// 按时间排序数据
				chartData.sort((a, b) => a[0] - b[0]);

				// 获取数据的时间范围
				const minDate = new Date(Math.min(...chartData.map(item => item[0])));
				const maxDate = new Date(Math.max(...chartData.map(item => item[0])));

				// 自定义X轴刻度，确保显示所有日期
				const xAxisTickValues = [];
				const uniqueDates = [...new Set(this.batteryData.map(item => item.createDate.split(' ')[0]))];

				uniqueDates.forEach(dateStr => {
					const date = new Date(dateStr);
					xAxisTickValues.push(date.getTime());
				});

				return {
					backgroundColor: 'rgba(255, 255, 255, 0.9)',
					tooltip: {
						trigger: 'item',
						backgroundColor: 'rgba(255, 255, 255, 0.95)',
						borderColor: '#ddd',
						borderWidth: 1,
						padding: 12,
						textStyle: {
							color: '#333'
						},
						formatter: function(params) {
							const value = params.data;
							const date = new Date(value[0]);
							const formattedDate =
								`${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;

							return `<div style="font-weight: bold;">${formattedDate}</div>
                   <div>电池电量: <span style="color:${value[2] === 'low' ? '#F56C6C' : (value[2] === 'medium' ? '#E6A23C' : '#67C23A')}">${value[1]}%</span></div>
                   <div>状态: ${value[1] < 20 ? '<span style="color:#F56C6C">电量极低</span>' : (value[1] < 50 ? '<span style="color:#E6A23C">电量中等</span>' : '<span style="color:#67C23A">电量充足</span>')}</div>`;
						}
					},
					legend: {
						data: ['电量数据'],
						top: '5%',
						textStyle: {
							color: '#606266',
							fontFamily: 'Inter, sans-serif'
						}
					},
					xAxis: {
						type: 'time',
						boundaryGap: false,
						min: minDate,
						max: maxDate,
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						axisTick: {
							alignWithLabel: true,
							// 显示所有日期的刻度
							interval: function(index, value) {
								// 每24小时显示一个刻度
								return true;
							},
							// 只显示有数据的日期
							show: function(params) {
								return xAxisTickValues.includes(params.value);
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(0, 0, 0, 0.05)'
							}
						},
						axisLabel: {
							formatter: function(value) {
								const date = new Date(value);
								// 显示日期和小时
								return `${date.getMonth() + 1}/${date.getDate()} ${date.getHours()}:00`;
							},
							fontFamily: 'Inter, sans-serif',
							fontSize: 16,
							rotate: 45 // 旋转标签，避免重叠
						}
					},
					yAxis: {
						type: 'value',
						min: 0,
						max: 100,
						axisLine: {
							lineStyle: {
								color: '#909399'
							}
						},
						splitLine: {
							show: true,
							lineStyle: {
								color: 'rgba(0, 0, 0, 0.05)'
							}
						},
						axisLabel: {
							formatter: '{value}%',
							fontFamily: 'Inter, sans-serif',
							fontSize: 16,
						}
					},
					grid: {
						top: '15%',
						left: '3%',
						right: '4%',
						bottom: '15%', // 增加底部边距，避免旋转的标签被遮挡
						containLabel: true
					},
					toolbox: {
						show: true,
						feature: {
							dataZoom: {
								yAxisIndex: 'none'
							},
							restore: {},
							saveAsImage: {}
						}
					},
					series: [{
							name: '电量数据',
							type: this.chartType,
							data: chartData,
							symbolSize: 8,
							itemStyle: {
								normal: {
									opacity: 0.8,
									color: function(params) {
										return params.data[2] === 'low' ? '#F56C6C' :
											params.data[2] === 'medium' ? '#E6A23C' : '#67C23A';
									}
								},
								emphasis: {
									opacity: 1,
									shadowBlur: 10,
									shadowColor: 'rgba(0, 0, 0, 0.3)'
								}
							},
							animationDuration: 1000,
							animationEasing: 'elasticOut'
						},
						// 添加低电量参考线
						{
							type: 'line',
							silent: true,
							lineStyle: {
								color: '#F56C6C',
								width: 1,
								type: 'dashed'
							},
							data: [
								[minDate, 20],
								[maxDate, 20]
							]
						}
					]
				};
			},

			// 更新图表
			updateChart() {
				if (!this.batteryChart) return;

				// 获取新的图表配置
				const option = this.getChartOptions();

				// 应用新配置
				this.batteryChart.setOption(option, true);
			},

			// 调整图表大小
			resizeChart() {
				if (this.batteryChart) {
					this.batteryChart.resize();
				}
			},

			// 切换全屏
			toggleFullscreen() {
				this.isFullscreen = !this.isFullscreen;

				const chartContainer = this.$refs.chartContainer;
				if (this.isFullscreen) {
					if (chartContainer.requestFullscreen) {
						chartContainer.requestFullscreen();
					} else if (chartContainer.webkitRequestFullscreen) {
						chartContainer.webkitRequestFullscreen();
					} else if (chartContainer.msRequestFullscreen) {
						chartContainer.msRequestFullscreen();
					}
				} else {
					if (document.exitFullscreen) {
						document.exitFullscreen();
					} else if (document.webkitExitFullscreen) {
						document.webkitExitFullscreen();
					} else if (document.msExitFullscreen) {
						document.msExitFullscreen();
					}
				}

				// 确保全屏切换后图表正确渲染
				setTimeout(() => {
					this.resizeChart();
				}, 300);
			},

			// 导出图表
			exportChart() {
				if (this.batteryChart) {
					this.batteryChart.getDataURL({
						type: 'png',
						pixelRatio: 2,
						backgroundColor: '#fff'
					});

					this.$message({
						message: '图表导出功能已触发',
						type: 'info'
					});
				}
			},

			// 获取设备状态
			getDeviceStatus(batteryLevel) {
				if (batteryLevel < 20) return '低电量';
				return '正常';
			},

			// 获取电池状态描述
			getBatteryStatus(batteryLevel) {
				if (batteryLevel < 20) return '电量极低';
				if (batteryLevel < 50) return '电量中等';
				return '电量充足';
			},

			// 格式化日期
			formatDate(date) {
				if (!date) return '';
				const d = new Date(date);
				return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')}`;
			},

			// 格式化时间
			formatTime(date) {
				if (!date) return '';
				const d = new Date(date);
				return `${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
			},

			// 格式化日期时间
			formatDateTime(date) {
				if (!date) return '';
				const d = new Date(date);
				return `${d.getFullYear()}-${(d.getMonth() + 1).toString().padStart(2, '0')}-${d.getDate().toString().padStart(2, '0')} ${d.getHours().toString().padStart(2, '0')}:${d.getMinutes().toString().padStart(2, '0')}`;
			},

			// 获取电池状态颜色
			getBatteryColor(batteryLevel) {
				if (batteryLevel < 20) return '#F56C6C';
				if (batteryLevel < 50) return '#E6A23C';
				return '#67C23A';
			},

			// 获取电池状态文字颜色
			getBatteryColorClass(batteryLevel) {
				if (batteryLevel < 20) return 'text-danger';
				if (batteryLevel < 50) return 'text-warning';
				return 'text-success';
			},

			// 获取设备状态标签类型
			getStatusType(status) {
				switch (status) {
					case '正常':
						return 'success';
					case '低电量':
						return 'warning';
					case '离线':
						return 'danger';
					default:
						return 'info';
				}
			},

			// 应用筛选条件
			applyFilter() {
				// 实际应用中这里会发送API请求
				console.log('应用筛选条件:', this.filterForm);
				this.generateMockData();
			},

			// 重置筛选条件
			resetFilter() {
				this.filterForm = {
					deviceId: 'DEV-001',
					dateRange: [
						new Date(new Date().setDate(new Date().getDate() - 30)),
						new Date()
					]
				};
				this.searchQuery = '';
				this.applyFilter();
			},

			// 处理分页大小变化
			handleSizeChange(newSize) {
				this.pageSize = newSize;
			},

			// 处理页码变化
			handleCurrentChange(newPage) {
				this.currentPage = newPage;
			},

			// 查看详情
			viewDetails(row) {
				console.log('查看详情:', row);
				this.$message({
					message: `查看 ${row.createDate} 的详细数据`,
					type: 'info'
				});
			},

			// 处理行点击
			handleRowClick(row) {
				console.log('行点击:', row);
			},

			// 返回
			goBack() {
				console.log('返回上一页');
				this.$message({
					message: '返回设备列表',
					type: 'info'
				});
			},

			// 导出数据
			exportData() {
				console.log('导出数据');
				this.$message({
					message: '数据导出中...',
					type: 'info'
				});
			},

			// 刷新数据
			refreshData() {
				console.log('刷新数据');
				this.generateMockData();
				this.$message({
					message: '数据已刷新',
					type: 'success'
				});
			}
		}
	};
</script>

<style scoped>
	.device-battery-container {
		width: 96%;
		padding: 10px;
	}

	/* 自定义样式 */
	.el-card {
		border-radius: 8px;
		transition: all 0.3s ease;
	}
	
	.box {
		position: fixed;
		width: 80%;
		height: 60%;
		background-color: white;
		border-radius: 10px;
	}

	.el-card:hover {
		box-shadow: 0 8px 16px rgba(0, 0, 0, 0.08);
		transform: translateY(-2px);
	}

	.el-table .cell {
		white-space: nowrap;
	}

	.el-progress-bar__outer {
		height: 12px !important;
	}

	.chart-container {
		position: relative;
		height: 400px;
	}

	/* 自定义动画效果 */
	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(10px);
		}

		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.fade-in {
		animation: fadeIn 0.5s ease-out forwards;
	}

	/* 图表动画 */
	.echarts-container {
		transition: all 0.3s ease;
	}
</style>